import { render, staticRenderFns } from "./AddTruck.vue?vue&type=template&id=4e6dbc70&"
import script from "./AddTruck.vue?vue&type=script&lang=js&"
export * from "./AddTruck.vue?vue&type=script&lang=js&"
import style0 from "./AddTruck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports